module.exports = __webpack_public_path__ + "img/Document.68654476.svg";